document.addEventListener("DOMContentLoaded", function () {
  function stickyAddToCart(event, isFocusWithin = false) {
    const section = document.querySelector(".custom_main_product")
    const quantityAddCartWrapper = document.querySelector(".sticky_add_to_cart")

    if (!section || !quantityAddCartWrapper) {
      console.error("Section or Add to Cart element not found!")
      return
    }

    const sectionHeight = section.offsetHeight

    if (window.scrollY > sectionHeight || isFocusWithin) {
      quantityAddCartWrapper.classList.add("active_sticky")
    } else {
      quantityAddCartWrapper.classList.remove("active_sticky")
    }
  }

  function getMainAtcButtonText() {
    const mainButton = document.querySelector(
      '.product__info-wrapper .product-form__submit[name="add"] > span:first-child',
    )
    return mainButton ? mainButton.textContent.trim() : null
  }

  function syncStickyAtcLabel() {
    const mainText = getMainAtcButtonText()
    if (!mainText) return

    document
      .querySelectorAll(
        '.sticky_add_to_cart .product-form__submit[name="add"] > span:first-child',
      )
      .forEach((stickyButton) => {
        if (stickyButton.textContent.trim() !== mainText) {
          stickyButton.textContent = mainText
        }
      })
  }

  window.addEventListener("scroll", stickyAddToCart)
  const stickyBar = document.querySelector(".sticky_add_to_cart")
  if (stickyBar) {
    stickyBar.addEventListener("focusin", function (event) {
      stickyAddToCart(event, true)
    })
    stickyBar.addEventListener("focusout", stickyAddToCart)
  }

  function observeMainAtcButton() {
    const mainButton = document.querySelector(
      '.product__info-wrapper .product-form__submit[name="add"] > span:first-child',
    )
    if (!mainButton || mainButton.dataset.stickyLabelObserved) return

    mainButton.dataset.stickyLabelObserved = "true"
    const buttonObserver = new MutationObserver(syncStickyAtcLabel)
    buttonObserver.observe(mainButton, {
      childList: true,
      characterData: true,
      subtree: true,
    })
    syncStickyAtcLabel()
  }

  stickyAddToCart()
  observeMainAtcButton()

  const domObserver = new MutationObserver(observeMainAtcButton)
  domObserver.observe(document.documentElement, {
    childList: true,
    subtree: true,
  })

  if (
    typeof subscribe === "function" &&
    typeof PUB_SUB_EVENTS !== "undefined"
  ) {
    subscribe(PUB_SUB_EVENTS.variantChange, syncStickyAtcLabel)
  }

  document.addEventListener("shopify:section:load", observeMainAtcButton)
})
